import { Injectable } from '@angular/core';
import { ConsumptionFilter } from '@app/shared/models/visualization/consumption';
import { isNil } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ConsumptionStoreService {
  private store: {
    consumptionFilter: ConsumptionFilter | null;
  } = {
    consumptionFilter: null,
  };

  private _consumptionFilter$ = new BehaviorSubject<ConsumptionFilter | null>(null);

  public get consumptionFilter$(): Observable<ConsumptionFilter> {
    return this._consumptionFilter$.pipe(filter((consumption: ConsumptionFilter | null): consumption is ConsumptionFilter => !isNil(consumption)));
  }

  public get consumptionFilter(): ConsumptionFilter | null {
    return this._consumptionFilter$.value;
  }

  public updateConsumptionFilter(value: ConsumptionFilter) {
    this.store.consumptionFilter = value;

    this._consumptionFilter$.next(Object.assign({}, this.store).consumptionFilter);
  }
}
